import { Location, navigate } from '@reach/router';
import * as React from 'react';
import { themr } from 'react-css-themr';
import ReactPaginate from 'react-paginate';
import AppConfig from '../AppConfig';
import { routeToString, stringToRoute } from '../utils/route';
export const defaultPaginationTheme = {
    break: '',
    previousLink: 'link',
    nextLink: 'link',
    container: 'pl0 list flex justify-center',
    page: 'ph2 mh2 f6',
    active: 'f6 paging ba b--paging br2',
    pageLink: 'link',
};
function DumpPagination({ pagingInfo, previousLabel = '⇠', nextLabel = '⇢', 
// router,
theme = {}, }) {
    const { page, total, limit } = pagingInfo;
    const pageCount = Math.ceil(total / limit);
    return (React.createElement(AppConfig, null, ({ routesMap }) => (React.createElement(Location, null, ({ location }) => {
        return (React.createElement(ReactPaginate, { previousLabel: previousLabel, nextLabel: nextLabel, breakLabel: React.createElement("a", { href: "" }, "..."), breakClassName: theme.break, pageCount: pageCount, marginPagesDisplayed: 2, forcePage: page - 1, 
            // initialPage={page - 1}
            pageRangeDisplayed: 5, onPageChange: ({ selected }) => {
                const route = stringToRoute(location.pathname, routesMap);
                if (!route) {
                    return;
                }
                const nextRoute = {
                    name: route.name,
                    params: {
                        ...route.params,
                        page: selected === 0 ? undefined : selected + 1,
                    },
                    query: { ...route.query },
                };
                const nextTo = routeToString(nextRoute, routesMap);
                navigate(nextTo);
                // pushRouter(nextRoute)
            }, previousLinkClassName: theme.previousLink, nextLinkClassName: theme.nextLink, containerClassName: theme.container, pageClassName: theme.page, activeClassName: theme.active, pageLinkClassName: theme.pageLink, hrefBuilder: selected => {
                const route = stringToRoute(location.pathname, routesMap);
                if (!route) {
                    return '/';
                }
                const nextRoute = {
                    name: route.name,
                    params: {
                        ...route.params,
                        page: selected === 1 ? undefined : selected,
                    },
                    query: { ...route.query },
                };
                return routeToString(nextRoute, routesMap);
            } }));
    }))));
}
const Pagination = themr('Pagination', defaultPaginationTheme, {
    composeTheme: 'softly',
})(DumpPagination);
export default Pagination;
//# sourceMappingURL=index.js.map